import { useWebHostingApi } from '@nucleus/web-theme';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

export const useCollection = (
  engineId: string | undefined,
  collectionType: 'postCollections' | 'tags' | 'authors' = 'postCollections',
  slugOrId?: string
) => {
  const api = useWebHostingApi();

  const options = api.postHub.collection.read.queryOptions({
    hubId: engineId!,
    collectionType: collectionType,
    collectionId: slugOrId!,
  });

  const defaultOptions = queryOptions({
    queryKey: options.queryKey,
    queryFn: async () => ({ collection: undefined }),
  }) as unknown as typeof options;

  return useSuspenseQuery(engineId === undefined || slugOrId === undefined ? defaultOptions : options);
};
